// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Progress } from 'reactstrap';

import {
    Col,
    Row,
} from "reactstrap"
import toastr from "toastr";

//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { withTranslation } from "react-i18next";
import { getQuestion, listSurvey, saveQuestionAnswer } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import SaveContinueModal from "components/_Common/SaveContinueModal";

const PhaseFour = props => {
    //meta title
    document.title = `${props.t("Survey Phase Four")}  | ${props.t("Participant")}`;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();

    const { surveyData, loading, error, successMsg } = useSelector((state) => state.Survey);



    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(state?.prev_index || 0);
    const [progressBar, setProgressBar] = useState(0);
    const [surveyLength, setSurveyLength] = useState(surveyData?.survey_answers?.length || 0);
    const [questions, setQuestions] = useState(surveyData?.survey?.phase_four || []);

    const [nextLoading, setNextLoading] = useState(false)
    const [openSaveContinueModal, setSaveContinueDeleteModal] = useState(false);
    const [answerQuestion, setAnswerQuestion] = useState('')


    useEffect(() => {
        fetchSurveyData();
    }, [])

    const fetchSurveyData = () => {
        dispatch(listSurvey("participant"))
    }


    useEffect(() => {

        if (surveyData?.survey_status == "complete") {
            navigate('/dashboard')
        }

        if (surveyData?.survey?.phase_four) {
            setSurveyLength(surveyData?.survey_answers?.length || 0);
            setProgressBar((Number(surveyLength) / Number(surveyData?.survey_length)) * 100);
            setQuestions(surveyData?.survey?.phase_four || []);
        }

    }, [surveyData, surveyLength]);



    useEffect(() => {

        if (questions && questions[currentQuestionIndex]) {
            const questionId = questions[currentQuestionIndex]?.id;

            if (questionId) {
                getQuestionById(questionId);
            }
        } else {

            navigate("/complete-self-servey/phase-three", {
                state: {
                    surveyData: surveyData,
                    prev_two_page_index: state?.prev_two_page_index
                }
            })
        }

    }, [currentQuestionIndex, questions]);


    const handleNext = () => {
        if (loading) {
            return
        }

        if (answerQuestion === '' || !answerQuestion) {
            toastr.error(props.t("PLEASE FILL ALL ANSWERS"));
            return;
        }

        let objValues = {
            "id": questions[currentQuestionIndex]?.id,
            "questionnaire_id": questions[currentQuestionIndex]?.questionnaire_id,
            "page": 1,
            "question_type": questions[currentQuestionIndex]?.question_type,
            "answer": answerQuestion
        }
        setNextLoading(true)
        dispatch(saveQuestionAnswer(objValues, "participant", (res) => {
            if (res?.status === 'success') {
                toastr.clear();
                toastr.success(res.message)
                fetchSurveyData()
                setNextLoading(false)

            } else {
                setNextLoading(false)
                toastr.error(res.message)
            }
        }));
        setAnswerQuestion('')
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {

            navigate('/complete-self-servey/phase-five', {
                state: {
                    surveyData: surveyData,
                    prev_index: currentQuestionIndex,
                    prev_two_page_index: state?.prev_two_page_index
                }
            });

        }
    };

    const handlePrevious = () => {
        setAnswerQuestion('')
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
           
        }
    };

    const saveAnswer = () => {
        if (answerQuestion === '' || !answerQuestion) {
            toastr.error(props.t("PLEASE FILL ALL ANSWERS"));
            return;
        }

        let objValues = {
            "id": questions[currentQuestionIndex]?.id,
            "questionnaire_id": questions[currentQuestionIndex]?.questionnaire_id,
            "page": 1,
            "question_type": questions[currentQuestionIndex]?.question_type,
            "answer": answerQuestion
        }

        dispatch(saveQuestionAnswer(objValues, "participant", (res) => {
            if (res?.status === 'success') {
                toastr.success(res.message)
                fetchSurveyData()
                setProgressBar((Number(surveyLength) / Number(surveyData?.survey_length)) * 100)
                setSurveyLength(surveyData?.survey_answers?.length)
                navigate("/save-survey")
            } else {
                toastr.error(res.message)
            }
        }));
    }

    const getQuestionById = async (id) => {
        dispatch(getQuestion(id, "participant", (res) => {
            if (res?.status === 'success') {
                setAnswerQuestion(res?.data?.schor_horizontal_textbox)

            }
        }));
    }

    const onClickMultiDelete = () => {
        navigate("/dashboard");
    };

    return (
        <React.Fragment>

            <div className="page-content">
                <div className="container-fluid">
                    <SaveContinueModal
                        show={openSaveContinueModal}
                        onSaveClick={onClickMultiDelete}
                        onCloseClick={() => setSaveContinueDeleteModal(false)}
                        loading={loading}
                    />

                    <Row>
                        <div className="self-survey-main phase-four-progress">
                            <div className="ques-progress">
                                <h3>{props.t('Institute on Governance')}</h3>
                                <Progress value={progressBar}>{progressBar?.toFixed(0)}%</Progress>
                            </div>
                            <div className="self-survey-inner question-form-inner">
                                {
                                    questions.length > 0 && currentQuestionIndex < questions.length && (
                                        <React.Fragment>
                                            <div className="d-flex"><div className="counting" style={{ marginRight: '5px' }}><strong>{state.prev_two_page_index + currentQuestionIndex + 2}.</strong></div> <div className="counting-cnt" dangerouslySetInnerHTML={{ __html: questions[currentQuestionIndex]?.text }}></div></div>
                                            {/* <h5>{currentQuestionIndex + 1}. {questions[currentQuestionIndex].text}</h5> */}
                                            <textarea value={answerQuestion} className="feed-ques-textarea" name="feed" rows="9" cols="100" onChange={(e) => setAnswerQuestion(e.target.value)}></textarea>
                                            <div className="space-survey-btn feed-back-button">
                                                {currentQuestionIndex > 0 && <button className="previous-ques" onClick={handlePrevious}>{props.t('Previous')}</button>}
                                                {currentQuestionIndex === 0 && <button className="previous-ques" onClick={() => navigate('/complete-self-servey/phase-three', { state: { surveyData: surveyData, prev_two_page_index: state?.prev_two_page_index } })}>{props.t('Previous')}</button>}
                                                <button className="save-continue-ques" onClick={saveAnswer}>{props.t('Save to Continue later')}</button>

                                                {
                                                    nextLoading
                                                        ?
                                                        <button disabled className="next-ques">
                                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                        </button>
                                                        :
                                                        <button className="next-ques" onClick={handleNext}>{props.t('Next')}</button>
                                                }
                                            </div>
                                        </React.Fragment>
                                    )
                                }
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

PhaseFour.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseFour);
